/**
 * Newsletter
 *
 * Ajaxify the Mailchimp signup form
 */

var Newsletter = (function($) {
  "use strict";

  function initAjaxSignup() {
    $(".js-mailchimp").on("submit", function(e) {
      var $form = $(this);
      var url = $form.attr("action");
      var $button = $form.find(".Form-button");
      var $message = $form.find(".Form-message");

      e.preventDefault();
      $button.attr("disabled", true);
      $message.text("");

      $.ajax({
        // GET & url for json slightly different
        type: "GET",
        url: url + "-json?c=?",
        data: $form.serialize(),
        dataType: "json",
        contentType: "application/json",
        timeout: 10000,
        error: function(resp) {
          $button.attr("disabled", false);
          $message.html(resp.msg.substring(4));
        },

        success: function(resp) {
          if (resp.result === "success") {
            $button
              .attr("disabled", false)
              .removeClass("Form-button--iconEmail")
              .addClass("Form-button--iconTick");
          } else {
            $button.attr("disabled", false);
            $message.html(resp.msg.substring(4));
          }
        }
      });
    });
  }

  function init() {
    // return early if no form present
    if (!$(".js-mailchimp").length) {
      return;
    }

    initAjaxSignup();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Newsletter.init);
